<template>
  <div class="dialog">
    <van-overlay :show="contactShow" @click="close">
      <div class="dialog_box">
        <p class="p" v-if="imgList.length > 0">扫描二维码添加课程助理</p>
        <div class="center" v-if="imgList.length > 0">
          <div class="img" v-for="(item, index) in imgList" :key="index">
            <img :src="item" alt="" />
          </div>
        </div>
        <div class="line" v-if="imgList.length > 0"></div>
        <div class="phone">
          <div class="phone-img">
            <img src="@/assets/images/setting/pnone1.png" alt="" />
            <span>联系方式</span>
          </div>
          <div class="phone-number">
            <p style="margin-bottom: 5px">{{ phone }}</p>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
export default {
  name: "contact-us",
  props: ["contactShow", "imgList", "phone"],
  data() {
    return {
      //   contactShow: true,
    };
  },
  created() {
    console.log(this.phone, "电话");
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  .van-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    .dialog_box {
      width: 270px;
      height: auto;
      border-radius: 8px;
      background: #fff;
      padding: 20px;
    }
    .p {
      font-size: 14px;
      color: #666;
      margin-bottom: 20px;
      text-align: center;
    }
    .center {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-bottom: 30px;
      .img {
        img {
          width: 100px;
          height: 100px;
          margin-bottom: 12px;
        }
        div {
          font-size: 12px;
          color: #767676;
          text-align: center;
        }
      }
    }
    .line {
      width: 270px;
      height: 1px;
      border: 1px dashed #979797;
      position: relative;
      left: -20px;
      bottom: 10px;
    }
    .phone {
      padding-top: 10px;
      font-size: 14px;
      color: #2e4344;
      display: flex;
      justify-content: space-around;
      .phone-img {
        img {
          width: 18px;
          height: 18px;
        }
        span {
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
